//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    mapState,
    mapMutations
  } from 'vuex'
  import {
    orderDetail,
    cancelOrder
  } from '../../service/index'
  import Api from '../../utils/config'
  import moment from 'moment'
  export default {
    data() {
      return {
        toPath: '',
        forecRedirected: false,
        leaveDialogVisible: false,
        orderDetail: {},
        orderGoodsList: [],
        payment: Api.payment,
        paymentMb: Api.paymentMb,
        dialogVisible: false,
        activeName: '1',
        showSuccessInfo: false,
        expireDate: "",
        canceling:false

      }
    },
    created() {
      const orderId = this.$route.params.orderId
      this.getOrderDetail(orderId)
      this.keepLang()
      if (this.$route.query.showSuccess === "true") {
        this.showSuccessInfo = true;
      }
    },
    computed: {
      ...mapState(['global']),
      invalidGoodList() {
        if (this.orderDetail.lackItems) {
          return JSON.parse(this.orderDetail.lackItems.replace("\\", ""))
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      //console.log(to.path)
      if (!this.forecRedirected && this.orderDetail.status == 1 && to.path != "/order" ) {
        this.leaveDialogVisible = true
        this.toPath = to.path
      } else {
        next()
      }
    },
    methods: {
       forceRirect() {
        this.leaveDialogVisible = false
        this.forecRedirected = true
        this.$router.push({
          path:  this.toPath,
          query: { cid: this.$route.query.cid}
        })
      },
      showDialog() {
        this.dialogVisible = true
      },
      async getOrderDetail(orderId) {
        const res = await orderDetail(orderId)
        if (res.status === 0) {
          this.orderDetail = res.data
          this.expireDate = moment(this.orderDetail.orderDate).add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          this.orderGoodsList = res.data.items
        }
      },
      payMoney(orderId) {
        // this.$router.push({path: '/pay/' + orderId})
        window.location = Api.payment + orderId
      },
      keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
      },
      async cancel(orderId) {
        if(this.canceling) return false
        this.canceling=true
        const res = await cancelOrder(orderId)
       
        if (res.status === 0) {
          this.dialogVisible = false
          this.canceling=false
          this.$message({

            message: this.$t('order.cancelSuccess'),
            type: 'success'
          })
          this.orderDetail.status = 12
        } else {
           this.canceling=false
          this.$message({
            message: this.$t('order.cancelFailed'),
            type: 'error'
          })
        }
      },
      exportDetail(orderId) {
        window.location.href = "/is/store/order/exportDetail/" + orderId;
      }
    }
  }




// WEBPACK FOOTER //
// ./src/components/order/OrderDetail.vue